module.exports = __webpack_public_path__ + "img/24.e5b84b83.png";